import "dayjs/locale/pt-br";

export function formatAmount(value, decimal = 2) {
  if (!value) value = 0;

  const og = Math.pow(10, decimal);
  value = Math.floor(value * og) / og;

  return Number(value.toFixed(decimal));
}

export function currencyMask(value, min = 2, max = 2) {
  value = formatAmount(value, min);

  return value.toLocaleString("pt-BR", {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  });
}

export function parseNumber(value) {
  if (!value) value = "0,00";

  return Number(value.replace(/\./g, "").replace(/,/g, "."));
}

export function capitalizeSentence(value) {
  if (!value) return "";

  const values = value.split(" ");

  return values
    .map((e) => capitalizeWord(e))
    .toString()
    .replaceAll(",", " ");
}

export function capitalizeWord(value) {
  if (!value) return "";

  return (
    value.toString().charAt(0).toUpperCase() +
    value.toString().substring(1).toLowerCase()
  );
}

export function formatDocument(value) {
  value = String(value).replace(/\D/g, "");

  if (value.length === 11)
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

  if (value.length === 14)
    return value.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );

  return value;
}

export function formatPhoneNumber(value, format = "BR") {
  const cleaned = value.replace(/\D/g, "");

  if (format === "US") {
    if (cleaned.length !== 11) return value;
    return `+${cleaned.slice(0, 1)} (${cleaned.slice(1, 4)}) ${cleaned.slice(
      4,
      7
    )}-${cleaned.slice(7)}`;
  }

  if (cleaned.length !== 13) return value;
  return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(
    4,
    9
  )}-${cleaned.slice(9)}`;
}

export function censorName(name) {
  const parts = name.split(" ");
  return parts.length <= 2
    ? `${parts[0]} *****`
    : `${parts[0]} ***** ${parts.at(-1)}`;
}

export function shortenName(value) {
  if (!value) return "--";

  const words = value.trim().split(" ");

  const firstName = words[0];
  const lastName = words.length >= 2 ? words[words.length - 1] : "";

  return `${
    firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()
  } ${
    lastName
      ? lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase()
      : ""
  }`;
}

export function formatResult(str) {
  const format = false;

  if (!format) return str;

  if (str.length % 2 !== 0) return str;

  return str.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
}
